// extracted by mini-css-extract-plugin
module.exports = {"name":"styles_name___LW8_","skeleton-animation":"styles_skeleton-animation__QRoH7"};